import React from 'react';
import Button from '../../button';
import useLayersStore from '../../stores/layersStore';

function LabelsButton() {
const annotationsEnabled = useLayersStore((state) => state.annotationsEnabled);
const setAnnotationsEnabled = useLayersStore((state) => state.setAnnotationsEnabled);
const closeAllAnnotations = useLayersStore((state) => state.closeAllAnnotations);
const setCurrentAnimation = useLayersStore((state) => state.setCurrentAnimation);
const featureEnabled = useLayersStore((state) => state.featureEnabled);

  if (!featureEnabled.labelsUi) return null;

  return (
    <div className='flex sm:gap-1'>
      <Button className='flex gap-1' onClick={() => {
        setCurrentAnimation(null);
        const newState = !annotationsEnabled;
        setAnnotationsEnabled(newState);
        // Force render update when enabling annotations
        if (newState) {
          const v3dApp = useLayersStore.getState().v3dApp;
          if (v3dApp?.renderer) {
            v3dApp.renderer.render(v3dApp.scene, v3dApp.camera);
          }
        }
      }} >
        <div>Labels</div>
      <div className="relative w-[22px] h-[12px] border border-black rounded-full">
        <div className={`absolute w-[7px] h-[7px] bg-black rounded-full transition-all duration-200 ${annotationsEnabled ? 'left-[10px]' : 'left-[1.5px]'}`} style={{top: '1.5px'}}/>
      </div>
      </Button>
      
      <Button onClick={closeAllAnnotations}>
        <div className="sm:hidden text-red-500 font-bold">✕</div>
        <div className="hidden sm:block">Close Labels</div>
      </Button>
     </div>
  );
}

export default LabelsButton; 